function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, i18n, InjectorHelper, InvoiceHelper, ThunkHelper } from 'invision-core';
import CustomerCareLocaleKeys from '../../locales/keys';
export var RETRIEVE_LEDGER_SUMMARY = {
  BEGIN: 'RETRIEVE_LEDGER_SUMMARY_BEGIN',
  SUCCESS: 'RETRIEVE_LEDGER_SUMMARY_SUCCESS',
  FAILURE: 'RETRIEVE_LEDGER_SUMMARY_FAILURE'
};
var RETRIEVE_LEDGER_SUMMARY_TYPES = [RETRIEVE_LEDGER_SUMMARY.BEGIN, RETRIEVE_LEDGER_SUMMARY.SUCCESS, RETRIEVE_LEDGER_SUMMARY.FAILURE];
export var RETRIEVE_OPEN_INVOICES_LIST = {
  BEGIN: 'RETRIEVE_OPEN_INVOICES_LIST_BEGIN',
  SUCCESS: 'RETRIEVE_OPEN_INVOICES_LIST_SUCCESS',
  FAILURE: 'RETRIEVE_OPEN_INVOICES_LIST_FAILURE'
};
var RETRIEVE_OPEN_INVOICES_LIST_TYPES = [RETRIEVE_OPEN_INVOICES_LIST.BEGIN, RETRIEVE_OPEN_INVOICES_LIST.SUCCESS, RETRIEVE_OPEN_INVOICES_LIST.FAILURE];
export var retrieveLedgerSummaryPromise = function retrieveLedgerSummaryPromise(dispatch, data) {
  var dispatchTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RETRIEVE_LEDGER_SUMMARY_TYPES;
  return ThunkHelper(dispatch, dispatchTypes, {
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId),
    method: 'post',
    url: 'SubscriberManagement/RetrieveLedgerSummary'
  });
};
export var retrieveLedgerSummary = function retrieveLedgerSummary(data) {
  var fetchOpenInvoicesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    return retrieveLedgerSummaryPromise(dispatch, data, fetchOpenInvoicesList ? RETRIEVE_OPEN_INVOICES_LIST_TYPES : RETRIEVE_LEDGER_SUMMARY_TYPES);
  };
};
export var RETRIEVE_INVOICES_LIST_DROPDOWN = {
  BEGIN: 'RETRIEVE_INVOICES_LIST_DROPDOWN_BEGIN',
  SUCCESS: 'RETRIEVE_INVOICES_LIST_DROPDOWN_SUCCESS',
  FAILURE: 'RETRIEVE_INVOICES_LIST_DROPDOWN_FAILURE'
};
var RETRIEVE_INVOICES_LIST_DROPDOWN_TYPES = [RETRIEVE_INVOICES_LIST_DROPDOWN.BEGIN, RETRIEVE_INVOICES_LIST_DROPDOWN.SUCCESS, RETRIEVE_INVOICES_LIST_DROPDOWN.FAILURE];
export var retrieveInvoicesForDropdown = function retrieveInvoicesForDropdown(data) {
  return function (dispatch) {
    return retrieveLedgerSummaryPromise(dispatch, data, RETRIEVE_INVOICES_LIST_DROPDOWN_TYPES);
  };
};
export var RETRIEVE_LEDGER_INVOICE = {
  BEGIN: 'RETRIEVE_LEDGER_INVOICE_BEGIN',
  SUCCESS: 'RETRIEVE_LEDGER_INVOICE_SUCCESS',
  FAILURE: 'RETRIEVE_LEDGER_INVOICE_FAILURE'
};
var RETRIEVE_LEDGER_INVOICE_TYPES = [RETRIEVE_LEDGER_INVOICE.BEGIN, RETRIEVE_LEDGER_INVOICE.SUCCESS, RETRIEVE_LEDGER_INVOICE.FAILURE];
export var retrieveLedgerInvoiceDetailsPromise = function retrieveLedgerInvoiceDetailsPromise(dispatch, invoiceDetailsRequest) {
  return ThunkHelper(dispatch, RETRIEVE_LEDGER_INVOICE_TYPES, {
    data: invoiceDetailsRequest.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, invoiceDetailsRequest.customerId),
    method: 'post',
    url: 'SubscriberManagement/RetrieveLedgerInvoiceDetails'
  });
};
export var retrieveLedgerInvoiceDetails = function retrieveLedgerInvoiceDetails(invoiceDetailsRequest) {
  return function (dispatch) {
    return retrieveLedgerInvoiceDetailsPromise(dispatch, invoiceDetailsRequest);
  };
};
export var UPDATE_BILLING_PAYMENTS_PAGE_NUMBER = 'UPDATE_BILLING_PAYMENTS_PAGE_NUMBER';
export var UPDATE_BILLING_PAYMENTS_DATE_RANGE = 'UPDATE_BILLING_PAYMENTS_DATE_RANGE';
export var updateDateRange = function updateDateRange(startDate, endDate, dateShortcut) {
  return {
    payload: {
      dateShortcut: dateShortcut,
      endDate: endDate,
      startDate: startDate
    },
    type: UPDATE_BILLING_PAYMENTS_DATE_RANGE
  };
};
export var UPDATE_BILLING_PAYMENTS_TYPE_FILTER = 'UPDATE_BILLING_PAYMENTS_TYPE_FILTER';
export var updateTypeFilter = function updateTypeFilter(typeFilter) {
  return {
    payload: {
      typeFilter: typeFilter
    },
    type: UPDATE_BILLING_PAYMENTS_TYPE_FILTER
  };
};
export var UPDATE_BILLING_PAYMENTS_INVOICE_FILTER = 'UPDATE_BILLING_PAYMENTS_INVOICE_FILTER';
export var updateInvoiceFilter = function updateInvoiceFilter(invoiceNumber) {
  return {
    payload: {
      invoiceFilter: invoiceNumber
    },
    type: UPDATE_BILLING_PAYMENTS_INVOICE_FILTER
  };
};
export var RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT = {
  BEGIN: 'RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT_BEGIN',
  SUCCESS: 'RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT_SUCCESS',
  FAILURE: 'RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT_FAILURE'
};
var RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT_TYPES = [RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT.BEGIN, RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT.SUCCESS, RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT.FAILURE];
export var retrieveAndOpenConvergentBillerLedgerInvoicePromise = function retrieveAndOpenConvergentBillerLedgerInvoicePromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_CONVERGENT_BILLER_LEDGER_INVOICE_CONTENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveConvergentBillerInvoice',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var retrieveAndOpenConvergentBillerLedgerInvoice = function retrieveAndOpenConvergentBillerLedgerInvoice(data) {
  return function (dispatch) {
    return retrieveAndOpenConvergentBillerLedgerInvoicePromise(dispatch, data).then(function (response) {
      var invoiceFileName = "".concat(data.customerName, " - ").concat(data.invoiceNumber, ".pdf");
      var openedInvoice = InvoiceHelper.openInvoice(response.InvoiceType, response.InvoiceContent, invoiceFileName);
      if (!openedInvoice) {
        var uiNotificationService = InjectorHelper.getUiNotificationService();
        var translatedMessage = i18n.translate(CustomerCareLocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_UNABLE_TO_OPEN);
        uiNotificationService.error(translatedMessage);
      }
    }).catch(function (error) {
      InjectorHelper.getUiNotificationService().transientError(error.translatedMessage);
    });
  };
};
export var CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT = {
  BEGIN: 'CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT_BEGIN',
  SUCCESS: 'CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT_SUCCESS',
  FAILURE: 'CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT_FAILURE'
};
var CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT_TYPES = [CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT.BEGIN, CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT.SUCCESS, CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT.FAILURE];
var createConvergentBillerAdjustmentPromise = function createConvergentBillerAdjustmentPromise(dispatch, data) {
  return ThunkHelper(dispatch, CREATE_CONVERGENT_BILLER_LEDGER_ADJUSTMENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CreateConvergentBillerAdjustment',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.customerId)
  });
};
export var createConvergentBillerAdjustment = function createConvergentBillerAdjustment(data) {
  return function (dispatch) {
    return createConvergentBillerAdjustmentPromise(dispatch, data);
  };
};
export var updatePageNumber = function updatePageNumber(data) {
  return {
    type: UPDATE_BILLING_PAYMENTS_PAGE_NUMBER,
    payload: data
  };
};
export var UPDATE_BILLING_PAYMENTS_PAGE_SIZE = 'UPDATE_BILLING_PAYMENTS_PAGE_SIZE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: UPDATE_BILLING_PAYMENTS_PAGE_SIZE,
    payload: pageSize
  };
};
export var RETREIVE_FUTURE_INVOICES = {
  BEGIN: 'RETREIVE_FUTURE_INVOICES_BEGIN',
  SUCCESS: 'RETREIVE_FUTURE_INVOICES_SUCCESS',
  FAILURE: 'RETREIVE_FUTURE_INVOICES_FAILURE'
};
var RETREIVE_FUTURE_INVOICES_TYPES = [RETREIVE_FUTURE_INVOICES.BEGIN, RETREIVE_FUTURE_INVOICES.SUCCESS, RETREIVE_FUTURE_INVOICES.FAILURE];
var retrieveFutureInvoicesPromise = function retrieveFutureInvoicesPromise(dispatch, futureInvoiceRequest, customerId) {
  return ThunkHelper(dispatch, RETREIVE_FUTURE_INVOICES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RequestFutureInvoices',
    data: futureInvoiceRequest,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveFutureInvoices = function retrieveFutureInvoices(futureInvoiceRequest, customerId) {
  return function (dispatch) {
    return retrieveFutureInvoicesPromise(dispatch, futureInvoiceRequest, customerId);
  };
};
export var APPLY_CREDIT_NOTE = {
  BEGIN: 'APPLY_CREDIT_NOTE_BEGIN',
  SUCCESS: 'APPLY_CREDIT_NOTE_SUCCESS',
  FAILURE: 'APPLY_CREDIT_NOTE_FAILURE'
};
var APPLY_CREDIT_NOTE_TYPES = [APPLY_CREDIT_NOTE.BEGIN, APPLY_CREDIT_NOTE.SUCCESS, APPLY_CREDIT_NOTE.FAILURE];
var applyCreditNotePromise = function applyCreditNotePromise(dispatch, applyCreditNoteRequest) {
  return ThunkHelper(dispatch, APPLY_CREDIT_NOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/ApplyConvergentBillerCreditNote',
    data: applyCreditNoteRequest.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, applyCreditNoteRequest.customerId)
  });
};
export var applyCreditNote = function applyCreditNote(applyCreditNoteRequest) {
  return function (dispatch) {
    return applyCreditNotePromise(dispatch, applyCreditNoteRequest);
  };
};
export var RETRIEVE_ADJUSTMENT_DETAILS = {
  BEGIN: 'RETRIEVE_ADJUSTMENT_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_ADJUSTMENT_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_ADJUSTMENT_DETAILS_FAILURE'
};
var RETRIEVE_ADJUSTMENT_DETAILS_TYPES = [RETRIEVE_ADJUSTMENT_DETAILS.BEGIN, RETRIEVE_ADJUSTMENT_DETAILS.SUCCESS, RETRIEVE_ADJUSTMENT_DETAILS.FAILURE];
var retrieveAdjustmentDetailsPromise = function retrieveAdjustmentDetailsPromise(dispatch, retrieveAdjustmentDetailsRequest) {
  return ThunkHelper(dispatch, RETRIEVE_ADJUSTMENT_DETAILS_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveAdjustmentDetails',
    data: retrieveAdjustmentDetailsRequest.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, retrieveAdjustmentDetailsRequest.customerId)
  });
};
export var retrieveAdjustmentDetails = function retrieveAdjustmentDetails(retrieveAdjustmentDetailsRequest) {
  return function (dispatch) {
    return retrieveAdjustmentDetailsPromise(dispatch, retrieveAdjustmentDetailsRequest);
  };
};
export var UPDATE_OPEN_INVOICE_PAGE_NUMBER = 'UPDATE_OPEN_INVOICE_PAGE_NUMBER';
export var updateOpenInvoicesPageNumber = function updateOpenInvoicesPageNumber(pageNumber) {
  return {
    type: UPDATE_OPEN_INVOICE_PAGE_NUMBER,
    payload: pageNumber
  };
};
export var UPDATE_OPEN_INVOICE_DATE_RANGE = 'UPDATE_OPEN_INVOICE_DATE_RANGE';
export var updateOpenInvoicesDateRange = function updateOpenInvoicesDateRange(startDate, endDate, dateShortcut) {
  return {
    type: UPDATE_OPEN_INVOICE_DATE_RANGE,
    payload: {
      startDate: startDate,
      endDate: endDate,
      dateShortcut: dateShortcut
    }
  };
};
export var UPDATE_INVOICE_NUMBER_SEARCH_TERM = 'UPDATE_INVOICE_NUMBER_SEARCH_TERM';
export var updateInvoiceNumberSearchTerm = function updateInvoiceNumberSearchTerm(searchTerm) {
  return {
    type: UPDATE_INVOICE_NUMBER_SEARCH_TERM,
    payload: searchTerm
  };
};
export var SET_CURRENT_TAB_BILLING_LEDGER = 'SET_CURRENT_TAB_BILLING_LEDGER';
export var setCurrentTabBillingLedger = function setCurrentTabBillingLedger(selectedTab) {
  return {
    type: SET_CURRENT_TAB_BILLING_LEDGER,
    payload: selectedTab
  };
};
export var UPDATE_OPEN_INVOICE_PAGE_SIZE = 'UPDATE_OPEN_INVOICE_PAGE_SIZE';
export var updateOpenInvoicesPageSize = function updateOpenInvoicesPageSize(pageSize) {
  return {
    type: UPDATE_OPEN_INVOICE_PAGE_SIZE,
    payload: pageSize
  };
};
export var RESET_BILLING_LEDGER_STATE = 'RESET_BILLING_LEDGER_STATE';
export var resetBillingLedger = function resetBillingLedger() {
  return {
    type: RESET_BILLING_LEDGER_STATE
  };
};
export var RETRIEVE_BILL_ADJUSTMENT_CONTENT = {
  BEGIN: 'RETRIEVE_BILL_ADJUSTMENT_CONTENT_BEGIN',
  SUCCESS: 'RETRIEVE_BILL_ADJUSTMENT_CONTENT_SUCCESS',
  FAILURE: 'RETRIEVE_BILL_ADJUSTMENT_CONTENT_FAILURE'
};
var RETRIEVE_BILL_ADJUSTMENT_CONTENT_TYPES = [RETRIEVE_BILL_ADJUSTMENT_CONTENT.BEGIN, RETRIEVE_BILL_ADJUSTMENT_CONTENT.SUCCESS, RETRIEVE_BILL_ADJUSTMENT_CONTENT.FAILURE];
export var retrieveAndOpenBillAdjustmentPromise = function retrieveAndOpenBillAdjustmentPromise(dispatch, data) {
  return ThunkHelper(dispatch, RETRIEVE_BILL_ADJUSTMENT_CONTENT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveStatement',
    data: data.request,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, data.CustomerId)
  });
};
export var retrieveAndOpenBillAdjustmentStatement = function retrieveAndOpenBillAdjustmentStatement(data) {
  return function (dispatch) {
    return retrieveAndOpenBillAdjustmentPromise(dispatch, data).then(function (response) {
      var invoiceFileName = "".concat(data.AdjustmentId, ".pdf");
      var openedInvoice = InvoiceHelper.openBillAdjustmentStatement(response.StatementDocumentType, response.StatementContent, invoiceFileName);
      if (!openedInvoice) {
        var uiNotificationService = InjectorHelper.getUiNotificationService();
        var translatedMessage = i18n.translate(CustomerCareLocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_UNABLE_TO_OPEN);
        uiNotificationService.error(translatedMessage);
      }
    }).catch(function (error) {
      InjectorHelper.getUiNotificationService().transientError(error.translatedMessage);
    });
  };
};